// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Lp-z","slideIn":"Mp-z"};